import { FC } from "react";
import { Flex, Text } from "@chakra-ui/react";

import { EVAL_CRITERION } from "@shared/models";
import { MAX_SCORE } from "@containers/Evaluation/constants";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

interface ScoreBadgeProps {
  criterion: EVAL_CRITERION;
  score: number;
  size?: "sm" | "md";
}

/** Theme badges are hardcoded to one palette, so the tone is applied directly here. */
const getScoreTone = (score: number) => {
  if (score >= 4) return { bg: "score.highBg", color: "score.highText" };
  if (score >= 3) return { bg: "score.midBg", color: "score.midText" };

  return { bg: "score.lowBg", color: "score.lowText" };
};

const ScoreBadge: FC<ScoreBadgeProps> = ({ criterion, score, size = "md" }) => (
  <Flex
    {...getScoreTone(score)}
    align="center"
    gap="5px"
    w="max-content"
    h={size === "sm" ? "22px" : "26px"}
    px="8px"
    borderRadius="6px"
    fontSize={size === "sm" ? "11px" : "12px"}
    whiteSpace="nowrap"
  >
    <Text textTransform="capitalize" fontWeight={FONT_WEIGHT.HEAVY}>
      {criterion}
    </Text>
    <Text opacity={0.75}>
      {score}/{MAX_SCORE}
    </Text>
  </Flex>
);

export default ScoreBadge;
